import type { Page } from "@inertiajs/core"

/**
 * OKS-310 — Report an Inertia SPA navigation to the New Relic Browser agent
 * as a named route change.
 *
 * Inertia swaps page components client-side without a full reload, so without
 * this the whole session would collapse into a single long-lived browser page
 * view. On each `navigate`, we name the current route after the Inertia-
 * provided page URL and save the interaction, so per-screen performance is
 * legible in the Browser SPA dashboard.
 *
 * GUARD (mandatory): `window.newrelic` only exists when the APM agent is
 * connected (prod/dev2). In dev/test the agent is off and the global is
 * absent, so the guard short-circuits — no throw, no console error, no impact
 * on navigation. This keeps the change behaviour-neutral in CI.
 *
 * PII P0: the only value sent is `page.url` — a clean REST path with no
 * sensitive query strings. No brand_id / user_id / email / token is ever
 * transmitted as a custom attribute.
 *
 * Extracted as a named export (not inlined in `inertia.tsx`) so it can be
 * unit-tested in isolation with a stubbed `window.newrelic`.
 */
export function handleNewRelicNavigate(page: Page): void {
  if (window.newrelic) {
    window.newrelic.setCurrentRouteName(page.url)
    window.newrelic.interaction().save()
  }
}
